var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showAddSurveyButton)?_c('PageHeader',{attrs:{"title":_vm.pageTitle,"description":_vm.pageDescription,"button":{
      icon: 'fas fa-plus-circle',
      text: `Créer un sondage`,
      action: _vm.createGroup
    }}}):_c('PageHeader',{attrs:{"title":_vm.pageTitle,"description":_vm.pageDescription}}),_c('SurveysSubmenu'),_c('PageContent',[_c('MVPTable',{attrs:{"gridData":_vm.surveyGroups,"options":_vm.gridOptions,"showAllDetails":false},on:{"rowDoubleClicked":_vm.handleRowDoubleClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }